import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StyledDeleteIconWrapper, LoadingIndicator } from './styled';

export const DeleteIcon = ({ isDeleting, onClick }) => {
  if (isDeleting) {
    return (
      <StyledDeleteIconWrapper>
        <LoadingIndicator />
      </StyledDeleteIconWrapper>
    )
  }

  return (
    <StyledDeleteIconWrapper onClick={onClick}>
      <FontAwesomeIcon icon='trash-alt' />
    </StyledDeleteIconWrapper>
  )
}